import { mapGetters } from 'vuex';
import { successMessage, errorMessage } from '@/utils/message.js';
import accountInfoService from '../account-info.service.js';
import UploadImage from '@/components/upload-image/index.vue';
import regExp from '@/utils/regExp.js';
import VoiceMessage from '@/components/voice-message/index.vue';

export default {
  components: {
    UploadImage,
    VoiceMessage
  },
  data() {
    return {
      assignorIdTypeList: [],
      smsCodeShowCount: 60,
      smsCodeShowText: '获取验证码',
      step: 1,
      form: {
        assignor: '',
        assignorIdCard: '',
        assignorIdType: '',
        assignorMobile: '',
        assignorCode: '',
        verifyCode: '',
        files: [
          {imgEnumType: 5, title: '身份证个人面', filePaths: [], defaultImage: [], inputValue: null},
          {imgEnumType: 6, title: '身份证国徽面', filePaths: [], defaultImage: [], inputValue: null},
          {imgEnumType: 9, title: '授权委托书', filePaths: [], defaultImage: [], inputValue: null}
        ]
      },
      rules: {
        assignor: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        assignorIdType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        assignorIdCard: [
          { required: true, message: '请输入证件号', trigger: 'blur' },
          { pattern: regExp.idCard, message: '请输入正确的证件号', trigger: 'blur'}
        ],
        assignorMobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: regExp.phone, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ],
        assignorCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'captchaImageSrc',
      'ticket',
      'userType'
    ])
  },
  created() {
    this.updateCaptchaImage();
    this.getIdTypeList();
  },
  methods: {
    fileRules (item) {
      let required = true;
      return {
        required: required,
        message: '请上传' + item.title,
        trigger: 'change'
      };
    },
    uploadImage (index, event) {
      this.form.files[index].filePaths = event;
      if (event.length) {
        this.form.files[index].inputValue = event.length;
      } else {
        this.form.files[index].inputValue = null;
      }
    },

    // 获取字典：证件类型列表
    getIdTypeList() {
      this.$store.dispatch('getSelectDictList', 'ID_TYPE').then(res => {
        if (res.code === '0') {
          this.assignorIdTypeList = res.data;
        }
      });
    },
    // 更新图片验证码
    updateCaptchaImage() {
      this.$store.dispatch('getCodeImage').then(() => {
      }, error => {
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('更新验证码失败，请重试');
        }
      });
    },
    // 手机验证码倒计时
    countDownOfSmsCode() {
      let _this = this;
      if (this.smsCodeShowCount >= 1) {
        _this.timer = setInterval(function() {
          _this.smsCodeShowCount--;
          _this.smsCodeShowText = _this.smsCodeShowCount + 'S';
          if (_this.smsCodeShowCount <= 0) {
            _this.smsCodeShowText = '重新获取';
            _this.smsCodeShowCount = 60;
            clearInterval(_this.timer);
          }
        }, 1000);
      }
    },
    // 获取手机验证码
    getSmsCode() {
      const assignorMobile = this.form.assignorMobile;
      // if (!assignorMobile) {
      //   errorMessage('请先输入被授权人手机号码');
      //   return;
      // }
      // if (!RegExp.phone.test(assignorMobile)) {
      //   errorMessage('请输入正确的手机号');
      //   return;
      // }
      if (!this.form.verifyCode) {
        errorMessage('请先输入图片验证码');
        return;
      }
      if (this.form.verifyCode && this.form.verifyCode.length !== 4) {
        errorMessage('请输入正确的图片验证码');
        return;
      }
      const form = {mobile: assignorMobile, ticket: this.ticket, verifyCode: this.form.verifyCode};
      if (this.smsCodeShowCount === 60) {
        this.smsCodeShowText = '发送中...';
        this.$store.dispatch('getSmsCode', form).then(res => {
          if (res.code === '0') {
            this.countDownOfSmsCode();
            successMessage('验证码发送成功');
          }
        }, error => {
          this.updateCaptchaImage();
          this.smsCodeShowText = '重新获取';
          this.smsCodeShowCount = 60;
          if (error && error.reason) {
            errorMessage(error.reason);
          } else {
            errorMessage('获取验证码失败，请重试');
          }
        });
      }
    },
    validateForm() {
      let validStatus = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          validStatus = valid;
        }
      });
      return validStatus;
    },
    submit() {
      if (!this.validateForm()) { return; };
      let paramsFiles = [];
      this.form.files.forEach(item => {
        let tempItem = {
          fileName: item.title,
          imgEnumType: item.imgEnumType,
          urls: [item.filePaths[0].sourceImgUrl]
        };
        paramsFiles.push(tempItem);
      });

      let params = {
        companyForm: {
          ...this.form
        },
        type: this.userInfo.type,
        files: paramsFiles,
        changeType: 1
      };
      accountInfoService.updateUserInfo(params).then(res => {
        if (res && res.code === '0') {
          // 信息修改成功后 清除信息并跳转到登陆页面
          successMessage('信息变更成功');
          this.$store.commit('RESET_USER_INFO');
          window.localStorage.clear();
          this.$router.push('/signin');
        } else {
          errorMessage(res.reason);
        }
      }, error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 下一步
    nextStep() {
      if (!this.validateForm()) { return; };
      let params = {
        assignorMobile: this.form.assignorMobile,
        verifyCode: this.form.assignorCode
      };
      accountInfoService.authenticate(params).then(res => {
        if (res && res.code === '0') {
          console.log('下一步');
          this.$router.push('/person-center/account-info/reset-secondstep');
        } else {
          console.log('222');
          errorMessage(res.reason);
        }
      }, error => {
        console.log(error, 'dd');
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
};
